import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

/**
 * Formats Zod validation error messages to be more user-friendly.
 * - "Too small: expected string to have >=1 characters" → "This field is required"
 * - "Too small: expected string to have >=2 characters" → "Minimum length is 2 characters"
 */
export function formatValidationError(message: string | undefined) {
	if (!message) return message

	// Match Zod's too_small string validation pattern
	const minMatch = message.match(/Too small: expected string to have >=(\d+) characters?/)
	if (minMatch) {
		const minLength = Number.parseInt(minMatch[1], 10)
		if (minLength === 1) {
			return 'This field is required'
		}
		return `Minimum length is ${minLength} characters`
	}

	return message
}
